import { render, staticRenderFns } from "./FilesNavigationListItem.vue?vue&type=template&id=bd35fb3e"
import script from "./FilesNavigationListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesNavigationListItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports